import { ICursor } from './../../interaction/cursor-drawable.i';
import { InteractionSubContext } from './../../interaction/cursor-drawable.i';
import { ShapeType } from 'flux-definition';
import { DisplayView } from './display-view';

/**
 * This is the contianer that contains all the peieces that makes up
 * the shape view on the canvas. This is used by ShapeView.
 * The class represents the basic most requirements of the shape drawing/view
 * to be used by resources that talk to the canvas. This should not contain
 * any view (or model) logic but only facilitate a means to identify the view
 */
export class ShapeDisplayView extends DisplayView {
    constructor( name: string, type: ShapeType ) {
        super( name, type );
        if ( type !== ShapeType.Basic && type !== ShapeType.Dynamic &&
            type !== ShapeType.Image && type !== ShapeType.Freehand &&
            type !== ShapeType.EData ) {
                throw new Error( 'ShapeDisplayView cannot be created with ' + type + ' shape type.' );
        }
    }

    /**
     * Indicates if this display object is part of a ShapeView
     */
    public get isShapeView(): boolean {
        return true;
    }

    /**
     * Indicates if this display object is part of a ConnectorView
     */
    public get isConnectorView(): boolean {
        return false;
    }

    /**
     * Returns the cursor and tail defined for the given context.
     * The return value may be null if no cursor is availbale for the given context
     */
    public getCursor( contexts: InteractionSubContext[]): ICursor {
        return { cursor: 'default', tail: null, type: 'css', viewingArea: 'app' };
    }
}
